import { IPhone } from '../../types/newbuilding/phone';

export function getPhoneString(phone: IPhone | null | undefined) {
  return phone ? `${phone.countryCode}${phone.code}${phone.number}` : null;
}
